
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5784',
  depVersions: {
  "data-privacy-request-ui": "static-1.5784",
  "client-types": "static-1.496",
  "data-fetching-client": "static-1.9924",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8296",
  "hub-http-shared-msw-handlers": "static-1.10563",
  "hubspot-dlb": "static-2.1882",
  "HubStyleTokens": "static-2.11752",
  "I18n": "static-7.1667",
  "jasmine-runner": "static-1.6719",
  "quartz": "static-1.7411",
  "react-dlb": "static-1.88",
  "rpc-client-utils": "static-1.4931",
  "ui-components-test-utils": "static-1.5889",
  "UIComponents": "static-3.8698",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.91",
  "foundations-assets": "static-1.5148",
  "foundations-components": "static-1-ech-accordiontransition-jank.20",
  "foundations-components-test-utils": "static-1-ech-accordiontransition-jank.20",
  "foundations-theming": "static-1.4736",
  "hub-http": "static-1.6479",
  "quartz-config": "static-1.1189",
  "quartz-core": "static-1.6630",
  "quartz-routing": "static-1.841",
  "quick-fetch": "static-1.4109",
  "raven": "static-3.5925",
  "react": "static-7.192",
  "react-rhumb": "static-1.16983",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11413",
  "usage-tracker": "static-1.7622",
  "usage-tracker-anonymous": "static-1.6039",
  "usage-tracker-core": "static-1.7472",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4297",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3596",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3688",
  "quartz-webpack": "static-1.3635",
  "bend-plugin-quartz-routing": "static-1.489",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.86",
  "HeadJS": "static-2.793",
  "framer-motion": "static-1.76",
  "hs-test-utils-bend-plugin": "static-1.3407",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "ts-schema": "static-1.4271",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.88",
  "react-utils": "static-2.5534",
  "StyleGuideUI": "static-3.499",
  "jasmine": "static-4.4580",
  "bend-plugin-chirp-manifest": "static-1.341",
  "chirp-fetch": "static-1.2160",
  "HubStyle": "static-2.12059",
  "ui-addon-draggable": "static-3.5024",
  "cssUtils": "static-1.886",
  "hs-story-utils": "static-1.9693",
  "icons": "static-2.677",
  "react-create-root-preference": "static-1.66",
  "react-select-plus": "static-1.109",
  "react-virtualized": "static-2.104",
  "ui-images": "static-2.1238",
  "bend-plugin-foundations-components": "static-1-ech-accordiontransition-jank.20",
  "floating-ui": "static-1.62",
  "foundations-theming-specialty": "static-1.2452",
  "react-aria": "static-1.70",
  "tanstack-table": "static-1.59",
  "trellis-assets": "static-1.2544",
  "ui-fonts": "static-1.1014",
  "foundations-components-legacy": "static-1-ech-accordiontransition-jank.20",
  "bend-plugin-foundations-theming": "static-1.3219",
  "foundations-theming-base": "static-1.3721",
  "stylex": "static-1.38",
  "hs-locale-management": "static-1.270",
  "opentelemetry-fe-types": "static-1.35",
  "dispatcher": "static-1.142",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.873",
  "hubspotter-http": "static-1.4842",
  "mobile-manifest-mixins": "static-1.573",
  "module-federation": "static-1.30",
  "opentelemetry-fe": "static-1.410",
  "quartz-auth": "static-1.1086",
  "quartz-head": "static-1.1076",
  "quartz-i18n": "static-1.1086",
  "quartz-test": "static-1.1086",
  "quartz-tracking": "static-1.790",
  "trellis-components": "static-1.2563",
  "usage-tracker-container": "static-1.7612",
  "csstype": "static-1.50",
  "web-vitals": "static-1.12",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3411",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.75",
  "sassPrefix": "static-1.163",
  "opentelemetry-web": "static-1.11",
  "hubspotter-http-shared-msw-handlers": "static-1.10561",
  "usage-tracker-session-replay": "static-1.5308",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "trellis-theming": "static-1.1235",
  "tanstack-virtual": "static-1.36",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5784",
  "client-types": "/client-types/static-1.496",
  "data-fetching-client": "/data-fetching-client/static-1.9924",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8296",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10563",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyleTokens": "/HubStyleTokens/static-2.11752",
  "I18n": "/I18n/static-7.1667",
  "jasmine-runner": "/jasmine-runner/static-1.6719",
  "quartz": "/quartz/static-1.7411",
  "react-dlb": "/react-dlb/static-1.88",
  "rpc-client-utils": "/rpc-client-utils/static-1.4931",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5889",
  "UIComponents": "/UIComponents/static-3.8698",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.91",
  "foundations-assets": "/foundations-assets/static-1.5148",
  "foundations-components": "/foundations-components/static-1-ech-accordiontransition-jank.20",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1-ech-accordiontransition-jank.20",
  "foundations-theming": "/foundations-theming/static-1.4736",
  "hub-http": "/hub-http/static-1.6479",
  "quartz-config": "/quartz-config/static-1.1189",
  "quartz-core": "/quartz-core/static-1.6630",
  "quartz-routing": "/quartz-routing/static-1.841",
  "quick-fetch": "/quick-fetch/static-1.4109",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.192",
  "react-rhumb": "/react-rhumb/static-1.16983",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11413",
  "usage-tracker": "/usage-tracker/static-1.7622",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6039",
  "usage-tracker-core": "/usage-tracker-core/static-1.7472",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3596",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3688",
  "quartz-webpack": "/quartz-webpack/static-1.3635",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.489",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.86",
  "HeadJS": "/HeadJS/static-2.793",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3407",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "ts-schema": "/ts-schema/static-1.4271",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.88",
  "react-utils": "/react-utils/static-2.5534",
  "StyleGuideUI": "/StyleGuideUI/static-3.499",
  "jasmine": "/jasmine/static-4.4580",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.341",
  "chirp-fetch": "/chirp-fetch/static-1.2160",
  "HubStyle": "/HubStyle/static-2.12059",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5024",
  "cssUtils": "/cssUtils/static-1.886",
  "hs-story-utils": "/hs-story-utils/static-1.9693",
  "icons": "/icons/static-2.677",
  "react-create-root-preference": "/react-create-root-preference/static-1.66",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-virtualized": "/react-virtualized/static-2.104",
  "ui-images": "/ui-images/static-2.1238",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1-ech-accordiontransition-jank.20",
  "floating-ui": "/floating-ui/static-1.62",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2452",
  "react-aria": "/react-aria/static-1.70",
  "tanstack-table": "/tanstack-table/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.2544",
  "ui-fonts": "/ui-fonts/static-1.1014",
  "foundations-components-legacy": "/foundations-components-legacy/static-1-ech-accordiontransition-jank.20",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3219",
  "foundations-theming-base": "/foundations-theming-base/static-1.3721",
  "stylex": "/stylex/static-1.38",
  "hs-locale-management": "/hs-locale-management/static-1.270",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.35",
  "dispatcher": "/dispatcher/static-1.142",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.873",
  "hubspotter-http": "/hubspotter-http/static-1.4842",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.573",
  "module-federation": "/module-federation/static-1.30",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.410",
  "quartz-auth": "/quartz-auth/static-1.1086",
  "quartz-head": "/quartz-head/static-1.1076",
  "quartz-i18n": "/quartz-i18n/static-1.1086",
  "quartz-test": "/quartz-test/static-1.1086",
  "quartz-tracking": "/quartz-tracking/static-1.790",
  "trellis-components": "/trellis-components/static-1.2563",
  "usage-tracker-container": "/usage-tracker-container/static-1.7612",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.12",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3411",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.75",
  "sassPrefix": "/sassPrefix/static-1.163",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10561",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5308",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "trellis-theming": "/trellis-theming/static-1.1235",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
